import { useTranslation } from 'react-i18next';
import Pagination from './Pagination';

const PaginatedFooter = ({
  pagination,
  page,
  onPageChange,
  pageSize,
  onPageSizeChange,
  pageSizeOptions,
}) => {
  const { t } = useTranslation();

  if (!pagination?.total) return null;

  const start = (page - 1) * pagination.limit + 1;
  const end = Math.min(page * pagination.limit, pagination.total);

  return (
    <div className="mt-6 space-y-3">
      <p className="text-center text-xs text-zinc-600 dark:text-zinc-500">
        {t('common.showing', { start, end, total: pagination.total })}
      </p>
      <Pagination
        currentPage={page}
        totalPages={pagination.pages}
        onPageChange={onPageChange}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
};

export default PaginatedFooter;
